import script from "./ModeSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./ModeSwitch.vue?vue&type=script&setup=true&lang=js"

import "./ModeSwitch.vue?vue&type=style&index=0&id=6839fa75&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6839fa75"]])

export default __exports__